@if (showBasicLogin) {
  <h2>Not authorized</h2>
  <input type="password" placeholder="Password" [(ngModel)]="password" />
  <button (click)="authenticate()">Submit</button>
  @if (isLoading) {
    <span>loading...</span>
  }
}

@if (authorized) {
  <gax-ga-loading-progress-bar></gax-ga-loading-progress-bar>
  <app-top-navigation></app-top-navigation>
  <div #topOfPage></div>
  <router-outlet></router-outlet>
}
<pre class="pre--inline">
  {{ (userContext.valueChanges | async)?.data | json }}
</pre>
